var isMobile;
function checkDevice() {
    isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    if (isMobile) {
        $('body').addClass('mobileDevice');
    }
    else {
        $('body').removeClass('mobileDevice');
    }
    return isMobile;
}
function hasSomeParentTheClass(element, classname) {
    // console.log(element.className);
    if (element.className !== undefined) {
        if (element.className.split(' ').indexOf(classname) >= 0)
            return true;
        return element.parentNode && hasSomeParentTheClass(element.parentNode, classname);
    }
    else
        return false;
}
function checkMenuVisibility(scroll, limitMenu) {
    if (scroll >= limitMenu) {
        $('menu').addClass('hide');
    }
    else {
        $('menu').removeClass('hide');
    }
}
jQuery('document').ready(function ($) {
    checkDevice();
    var limitMenu = 300;
    var scroll = $(window).scrollTop();
    checkMenuVisibility(scroll, limitMenu);
    $(window).on('scroll', function (event) {
        var scroll = $(event.currentTarget).scrollTop();
        checkMenuVisibility(scroll, limitMenu);
    });
});
